module.exports = __webpack_public_path__ + "static/media/wendy.27c5e999.jpg";